// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"501":"99f8c669","672":"e6934a33","791":"11ebc1d8"}[chunkId] + ".chunk.js";
};